import { getReconCaseStatus } from "../../utils/case";
import { DEFAULT_RECON_MESSAGES } from "../../utils/case";
import formatDate from "./date-time/utils";

interface ReconData {
  reconCaseSystemID: string;
  submittedDate: string;
  caseOpenIndicator: string;
  changeRequestApplied: boolean;
  changeRequestDecision: string;
  requestID: string;
  conclusion?: string;
  decision?: string;
  investigation: string;
  attachmentName: string;
}

export const getReconDataForCase = (dataArray: ReconData[]) => {
    const {
      reconCaseSystemID,
      submittedDate,
      caseOpenIndicator,
      changeRequestApplied,
      changeRequestDecision,
      requestID,
      conclusion,
      decision,
      investigation,
      attachmentName
    } = dataArray[0];

    const conclusionText = conclusion || 'N/A';
    const decisionText = decision || 'N/A';

    return {
      attachmentName,
      caseID: reconCaseSystemID,
      caseOpenIndicator,
      changeRequestApplied,
      changeRequestDecision,
      changeRequestID: requestID,
      conclusion: caseOpenIndicator === 'N' ? conclusionText : DEFAULT_RECON_MESSAGES.CONCLUSION,
      decision: caseOpenIndicator === 'N' ? decisionText : DEFAULT_RECON_MESSAGES.DECISION,
      investigation,
      submittedDate: formatDate(submittedDate),
      status: getReconCaseStatus(submittedDate, caseOpenIndicator)
    };
  };
